'use strict';
const MAX_ROUNDTRIP_MILLIS = 120000,
	MAX_POLLING_SKIP_NEXT = 5,
	MAX_POLLING_SKIP_NEXT_AFTER_COLLABORATION = 0,
	REVERT_MAX_POLLING_SKIP_NEXT_AFTER_EMPTY = 60;

module.exports = function GoldFileEventPoller(loadChangesHistory, goldFileChangesCache, collaborationModel, goldFileHistoryEvent, resourceManager, historyEnvelopesProcessor) {
	if (!loadChangesHistory || !goldFileChangesCache || !collaborationModel || !goldFileHistoryEvent || !resourceManager || !historyEnvelopesProcessor) {
		throw new Error('invalid-args');
	}

	let processingPolling = false, pollingSkipCount = 0, pollingSkipNext = 0, showSaveOnError = true, maxPollingSkipNext = MAX_POLLING_SKIP_NEXT, contiguousEmptyResults = 0;
	const self = this,
		getEventsNow = () => {
			if (processingPolling) {
				return Promise.resolve();
			}
			pollingSkipCount = 0;
			processingPolling = true;

			return loadChangesHistory(true)
			.then((historyEnvelopes) => historyEnvelopes.filter(goldFileHistoryEvent.hasRemoteEvents))
			.then(historyEnvelopes => {
				if (!historyEnvelopes || !historyEnvelopes.length) {
					contiguousEmptyResults = contiguousEmptyResults + 1;
					if (contiguousEmptyResults > REVERT_MAX_POLLING_SKIP_NEXT_AFTER_EMPTY) {
						maxPollingSkipNext = MAX_POLLING_SKIP_NEXT;
					}
					pollingSkipNext = Math.min(maxPollingSkipNext, pollingSkipNext + 1);
				} else {
					maxPollingSkipNext = MAX_POLLING_SKIP_NEXT_AFTER_COLLABORATION;
					pollingSkipNext = 0;
					contiguousEmptyResults = 0;
				}
				return historyEnvelopes;
			})
			.then((historyEnvelopes) => resourceManager.processAssetEvents(historyEnvelopes))
			.then(historyEnvelopesProcessor)
			.then(() => {
				if (goldFileChangesCache.hasEnvelopesPendingReciept(MAX_ROUNDTRIP_MILLIS)) {
					if (showSaveOnError) {
						collaborationModel.error('networkError');
						showSaveOnError = false;
					}
				}
			})
			.catch(() => false)
			.then(() => {
				processingPolling = false;
			});

		};

	self.setShowSaveOnError = (show) => showSaveOnError = show;
	self.getShowSaveOnError = () => showSaveOnError;

	self.getPollingSkipNext = () => pollingSkipNext;
	self.getMaxPollingSkipNext = () => maxPollingSkipNext;
	self.getPollingSkipCount = () => pollingSkipCount;
	self.getContiguousEmptyResults = () => contiguousEmptyResults;
	self.getEventsNow = getEventsNow;

	self.pollForEvents = () => {
		if (processingPolling) {
			return Promise.resolve();
		}
		const shouldSkip = pollingSkipCount < pollingSkipNext;

		if (shouldSkip) {
			pollingSkipCount = pollingSkipCount + 1;
			return Promise.resolve();
		}
		return getEventsNow();
	};
};
